import { makeActionCreator } from '../../config/store/utils'
import { getOnboardingStatusCached, clearOnboardingStatusCache } from '../../services/config.cached'
import { updateOnboardingStatus } from '../../services/config'

export const CLOSE_ONBOARDING_STATUS_SUCCESS = 'CLOSE_ONBOARDING_STATUS_SUCCESS'
export const onCloseOnboardingStatusSuccess = makeActionCreator(CLOSE_ONBOARDING_STATUS_SUCCESS)

export const GET_ONBOARDING_STATUS = 'GET_ONBOARDING_STATUS'
export const GET_ONBOARDING_STATUS_ERROR = 'GET_ONBOARDING_STATUS_ERROR'
export const GET_ONBOARDING_STATUS_SUCCESS = 'GET_ONBOARDING_STATUS_SUCCESS'
export const onGetOnboardingStatus = makeActionCreator(GET_ONBOARDING_STATUS)
export const onGetOnboardingStatusError = makeActionCreator(GET_ONBOARDING_STATUS_ERROR, 'payload')
export const onGetOnboardingStatusSuccess = makeActionCreator(GET_ONBOARDING_STATUS_SUCCESS, 'payload')

export const onInitOnboardingTutorialThunk = () => async dispatch => {
  dispatch(onGetOnboardingStatus())

  try {
    const { resp, source } = await getOnboardingStatusCached()
    const finalizado = resp?.data?.payload?.finalizado

    const shouldOpen = source === 'service' && !finalizado

    return dispatch(onGetOnboardingStatusSuccess({ open: shouldOpen }))
  } catch (error) {
    return dispatch(onGetOnboardingStatusError({ error }))
  }
}

export const UPDATE_ONBOARDING_STATUS = 'UPDATE_ONBOARDING_STATUS'
export const UPDATE_ONBOARDING_STATUS_ERROR = 'UPDATE_ONBOARDING_STATUS_ERROR'
export const UPDATE_ONBOARDING_STATUS_SUCCESS = 'UPDATE_ONBOARDING_STATUS_SUCCESS'
export const onUpdateOnboardingStatus = makeActionCreator(UPDATE_ONBOARDING_STATUS)
export const onUpdateOnboardingStatusError = makeActionCreator(UPDATE_ONBOARDING_STATUS_ERROR, 'payload')
export const onUpdateOnboardingStatusSuccess = makeActionCreator(UPDATE_ONBOARDING_STATUS_SUCCESS, 'payload')

export const onUpdateOnboardingStatusThunk = () => async dispatch => {
  dispatch(onUpdateOnboardingStatus())

  try {
    const { data } = await updateOnboardingStatus()
    clearOnboardingStatusCache()
    return dispatch(onUpdateOnboardingStatusSuccess({ open: !data.payload.finalizado }))
  } catch (error) {
    return dispatch(onUpdateOnboardingStatusError({ error }))
  }
}
